var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panels",
    {
      class: { "no-cassettes": _vm.cassettesToShow.length === 0 },
      attrs: { multiple: "", flat: "" },
      model: {
        value: _vm.tray,
        callback: function($$v) {
          _vm.tray = $$v
        },
        expression: "tray"
      }
    },
    [
      _vm._l(_vm.cassettesToShow, function(cassette) {
        return _c("cassette", {
          key: cassette.uuid,
          attrs: {
            cassette: cassette,
            connections: _vm.getCassetteConnections(cassette)
          },
          on: {
            "open-cassette-connection-menu": function($event) {
              return _vm.openMenu($event)
            },
            "open-cassette-form": function($event) {
              return _vm.$emit("open-cassette-form", $event)
            },
            "open-tube-form": _vm.openTubeForm,
            "open-delete-cassette-dialog": function($event) {
              return _vm.$emit("open-delete-cassette-dialog", $event)
            }
          }
        })
      }),
      _vm._v(" "),
      _vm.cassettesToShow && _vm.cassettesToShow.length === 0
        ? _c(
            "span",
            {
              style:
                _vm.cassettesToShow.length === 0
                  ? { "margin-top": "0" }
                  : { "margin-top": "45%" }
            },
            [_vm._v("\n    " + _vm._s(_vm.$t("DrawerHasNoCassettes")) + "\n  ")]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-343cdf20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-343cdf20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/InsidePlan/Drawer.vue
// module id = null
// module chunks = 